'use client';

import CustomLink from '../../ui/custom-link';

export const BettingAdvisory = ({ pickleballHref }: { pickleballHref: string }) => {
	const isLocalhost = pickleballHref?.startsWith('localhost');
	const pickleballUrl = `http${isLocalhost ? '' : 's'}://${pickleballHref}`;

	return (
		<p className="mb-2 text-sm font-medium text-gray-500 p-2 bg-purple-50 rounded-lg">
			{`BETTING ADVISORY: Pickleball.com is not a gambling operator and does not provide or facilitate real-money gambling services.
			 Content on this site may contain links to third-party gambling sites,
			  but this does not constitute an endorsement, sponsorship, or guarantee of those sites.
			   Please Gamble Responsibly. Call 1-800-GAMBLER for help. Go to our `}
			<CustomLink href={`${pickleballUrl}/betting-disclaimer`} className="underline text-[#535862] font-semibold">
				{'Betting Disclaimer'}
			</CustomLink>
			{` page for more information.`}
		</p>
	);
};
